const externalUrls = [
  {
    domain: 'ravenol.de',
    baseUrl: 'https://www.ravenol.de',
    languages: ['de', 'en'],
    productPath: '/oilguideapi/',
    fallback: true
  },
  {
    domain: 'ravenol.pl',
    baseUrl: 'https://www.ravenol.pl',
    languages: ['pl'],
    productPath: '/szukaj?controller=search&search_query='
  },
  {
    domain: 'new.ravenol.pl',
    baseUrl: 'https://www.ravenol.pl',
    languages: ['pl'],
    productPath: '/'
  },
  {
    domain: 'ravenol.ro',
    baseUrl: 'https://ravenol.ro',
    languages: ['ro'],
    productPath: '/index.php?page=search&action=products&query='
  },
  {
    domain: 'ravenol.co.za',
    baseUrl: 'https://shop.ravenol.co.za',
    languages: ['en-ZA'],
    productPath: '/?s='
  },
  {
    domain: 'shop.ravenol.co.za',
    baseUrl: 'https://shop.ravenol.co.za',
    languages: ['en-ZA'],
    productPath: '/?s='
  },
  {
    domain: 'ravenol-direct.uk',
    baseUrl: 'https://www.ravenol-direct.uk',
    languages: ['en'],
    productPath: '/search/for/'
  },
  {
    domain: 'ravenol.es',
    baseUrl: 'https://ravenol.es',
    languages: ['es'],
    productPath: '/?post_type=product&dgwt_wcas=1&s='
  }
];

/**
 * Check if locale has a matching external domain and returns domain object if found
 * @param {string} locale
 * @returns {object}
 */
export function getLocaleMatchingDomain (locale) {
  return externalUrls.find(url => url.languages.includes(locale));
}

/**
 * Find matching external domain product URL by URLSearchParam (domain)
 * @param {number} articleNumber
 * @param {string} locale
 * @returns {string}
 */
export default function getExternalProductLink ({ articleNumber, locale = '', label = '' }) {
  let externalProductLink;

  const URLparams = new URLSearchParams(location.search);
  const fallbackDomain = externalUrls.find(url => url.fallback);
  // For Spanish (es) locale, fallback to German (de) instead of English
  const fallbackAvailableLocale = fallbackDomain.languages.includes(locale)
    ? '/' + locale
    : locale === 'es' ? '/de' : '/en';

  if (!URLparams.has('domain')) {
    // If no domain param is set return ravenol.de link in selected language (if available)
    externalProductLink = fallbackDomain.baseUrl + fallbackAvailableLocale + fallbackDomain.productPath + articleNumber;
  } else {
    const domainParam = URLparams.get('domain');
    const domainItemInList = externalUrls.find(url => url.domain === domainParam);

    if (domainItemInList) {
      const { baseUrl, productPath, languages } = domainItemInList;
      let availableLocale = '';
      if (languages.length > 1) {
        availableLocale = languages.includes(locale) ? '/' + locale : '/en';
      }
      // ravenol.co.za doesn't support searching by article number => search by title/label instead
      if ((domainParam === 'ravenol.co.za' || domainParam === 'shop.ravenol.co.za') && label) {
        externalProductLink = baseUrl + availableLocale + productPath + encodeURIComponent(label);
      } else {
        externalProductLink = baseUrl + availableLocale + productPath + articleNumber;
      }
    } else {
      externalProductLink = fallbackDomain.baseUrl + fallbackAvailableLocale + fallbackDomain.productPath + articleNumber;
    }
  }

  return externalProductLink;
}
